const template = `
  <div class="modal-header">
	<h4 class="text-center">{{loadingMessage}}</h4>
  </div>
  <div class="modal-body text-center">
	<div class="text-center">
	  <div class="preloader pl-xxl">
		  <svg class="pl-circular" viewBox="25 25 50 50">
			  <circle class="plc-path" cx="50" cy="50" r="20" />
		  </svg>
	  </div>
	</div>
  </div>
`;

function LoadingService($rootScope, $uibModal, promiseTracker) {
	const svc = this;

	let loadingModal;
	const loadingModalScope = $rootScope.$new();


	svc.watch = watch;
	svc.getTracker = getTracker;
	svc.isActive = isActive;

	init();

	function init() {
		svc.overlayLoader = getTracker();
		$rootScope.$watch(svc.overlayLoader.active, (curr, prev) => {
			if(curr && curr != prev) {
				showModal();
			} else if(loadingModal && curr === false && prev === true) {
				loadingModal.dismiss();
			}
		});
	}

	function getTracker() {
		return promiseTracker({
			activationDelay: 0,
			minDuration: 500
		});
	}

	function showModal() {
		loadingModal = $uibModal.open({
			template,
			scope: loadingModalScope,
			backdrop: "static" /*  this prevent user interaction with the background  */,
			keyboard: false
		});
	}

	function watch(promise, message = "Loading...") {
		loadingModalScope.loadingMessage = message;
		svc.overlayLoader.addPromise(promise);
		return promise;
	}

	function isActive() {
		return svc.overlayLoader.active();
	}

	return svc;
}

export default angular
	.module("vesl.services.loading-service", [])
	.service("loadingService", LoadingService).name;
